import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { UserService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import messages from './MLOutOfSequenceConflictComponent.messages';
import metadata from './MLOutOfSequenceConflictComponent.metadata.json5';

const oosTransactionBlock = 'unableToProceedOOSTransaction';
const contactUsBlock = 'contactUsToResolveOOSConflict';

function MLOutOfSequenceConflictComponent(props) {
    const { isOOSConflict, isAgent } = props;
    const [currentUser, setCurrentUser] = useState(null);
    const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);
    const { authHeader } = useAuthentication();

    const {
        clearAlerts,
        addErrorAlert,
        clearManyBlockAlerts
    } = MLNotificationBlockUtil();

    const isIAOrPCSOrMetGAAgent = useCallback(() => {
        if (!currentUser) {
            return false;
        }
        return currentUser.isIA || currentUser.isPCS || currentUser.isMetGA;
    }, [currentUser]);

    const oosConflictAlertMessage = useCallback(() => {
        clearAlerts();
        if (isIAOrPCSOrMetGAAgent()) {
            addErrorAlert({...messages.unableToProceedCallAgency}, oosTransactionBlock);
        } else {
            const errorMessage3 = messages.contactUs;
            addErrorAlert(errorMessage3, contactUsBlock);
        }
    }, [addErrorAlert, clearAlerts, isIAOrPCSOrMetGAAgent]);

    useEffect(() => {
        if (initialLoadCompleted) {
            if(isOOSConflict) {
                oosConflictAlertMessage();
            } else {
                clearManyBlockAlerts([oosTransactionBlock, contactUsBlock])
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialLoadCompleted, isOOSConflict]);

    // Initial Load
    useEffect(() => {
        if (isAgent) {
            UserService.getCurrentUser(authHeader).then((user) => {
                setCurrentUser(user);
                setInitialLoadCompleted(true);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const overrides = {
        anyConflictsDiv: {
            visible: isOOSConflict
        }
    };

    return <MetadataContent uiProps={metadata} overrideProps={overrides} />;

};

MLOutOfSequenceConflictComponent.propTypes = {
    isOOSConflict: PropTypes.bool.isRequired,
    isAgent: PropTypes.bool.isRequired,
};

MLOutOfSequenceConflictComponent.defaultProps = {
    isOOSConflict: false,
    isAgent: false,
};

export default MLOutOfSequenceConflictComponent;
